import axios from "axios";
import router from "./router";

let baseUrl =
  "https://3t2jdrbo8i.execute-api.ap-southeast-2.amazonaws.com/waves";
let host = window.location.host;
if (
  host == "localhost:8080" ||
  host == "localhost:8081" ||
  host == "localhost:8082"
) {
  baseUrl = "http://localhost:9080/waves";
} else if (host.substring(0, 4) == "dev.") {
  baseUrl = "https://urtrozywz9.execute-api.ap-southeast-2.amazonaws.com/waves";
} else if (
  host.split(".")[0] == "training" ||
  host.split(".")[0] == "wavestraining"
) {
  baseUrl =
    "https://3t2jdrbo8i.execute-api.ap-southeast-2.amazonaws.com/waves_training";
  document.title = "Waves Training";
  changeFavicon(
    "https://nzsls.s3.ap-southeast-2.amazonaws.com/siteFiles/pinkLogo.ico"
  );
} else if (host == "10.0.0.141:9080") {
  baseUrl = "http://10.0.0.141:9080/waves";
} else if (host == "wavesapp.local") {
  baseUrl = "http://wavesapp.local:9080/waves";
}

function changeFavicon(src) {
  var link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  link.href = src;
}

let api = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

let sessionid = localStorage.getItem("ss-sessionid");

if (sessionid) {
  api.defaults.headers.common["ss-sessionid"] = sessionid;
}

// Add a response interceptor
api.interceptors.response.use(
  function(response) {
    if (response.headers["ss-sessionid"]) {
      localStorage.setItem("ss-sessionid", response.headers["ss-sessionid"]);
      api.defaults.headers.common["ss-sessionid"] =
        response.headers["ss-sessionid"];
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default api;
